import { interceptor } from "./interceptor";
import axios from "axios";

export const ax = axios.create({
    baseURL: "https://loyaltyapi.dilipsindia.com",
    //    baseURL: "https://dilipsindiaapi.stellifyflows.in/",
    //    baseURL: "http://localhost:5001",
});

interceptor(ax);